'use client'

import { NavigationOpenables } from 'shared/types/navigation'

import useSearchDropdown from '../hooks/useSearchDropdown'

import SearchContainer from './SearchContainer'
// Dynamic import of SearchDropdown is omitted intentionally to ensure the fastest UI render and avoid flickering.
import SearchDropdown from './SearchDropdown'
import SearchInput from './SearchInput'

interface SearchProps {
  open: boolean
  setOpen: (name: NavigationOpenables, value: boolean) => void
  // The ribbon is owned by content - the navigation passes whether it is shown.
  isRibbonActive?: boolean
}

const Search = ({ open: isOpen, setOpen, isRibbonActive }: SearchProps) => {
  const {
    productResults,
    searchQuerySuggestionResults,
    dropdownMode,
    query,
    productsQueryID,
    customerId,
    isLoading,
    handleOpen,
    handleClose,
    setQuery,
    handleSearchSubmit
  } = useSearchDropdown({ isOpen, setOpen })

  return (
    <SearchContainer isOpen={isOpen} onClose={handleClose}>
      <SearchInput
        query={query}
        setQuery={setQuery}
        isOpen={isOpen}
        open={handleOpen}
        handleSearchSubmit={handleSearchSubmit}
      />
      <SearchDropdown
        query={query}
        productsQueryID={productsQueryID}
        customerId={customerId}
        isOpen={isOpen}
        isLoading={isLoading}
        productResults={productResults}
        querySuggestions={searchQuerySuggestionResults}
        dropdownMode={dropdownMode}
        handleSearchSubmit={handleSearchSubmit}
        isRibbonActive={isRibbonActive}
      />
    </SearchContainer>
  )
}

export default Search
